<template>
  <app-layout>
    <template v-slot:adminnav> </template>
    <div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-3">
        <PageTitle class="font-semibold text-lg text-gray-800 leading-tight">
          Employee Onboard
        </PageTitle>
        <p class="text-xs">
          We’re updating the cards and ranking all the time, so check back
          regularly.
        </p>
      </div>
    
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <jet-button
        class="bg-green-500 rounded text-white hover:bg-green-700 hover:no-underline px-2 ml-2 py-1 cursor-pointer text-sm"
        @click="sendInvitation"
      >
        <i class="fa fa-envelope" aria-hidden="true"></i>
        &nbsp; Send Invitation Link</jet-button
      >
        <div>
          <div>
            <div class="row"></div>
            <div class="mt-2">
              <div
                class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg"
              >
                <BsIndex
                  :slug="slug"
                  :routeDef="moduleRoute"
                  :headersDef="headers"
                  :dataRoute="dataRoute"
                >
                </BsIndex>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
  <InvitationPopup
    :visible="showInvitationPopup"
    :users="users"
    :slug="slug" 
    :moduleRoute="moduleRoute"
    @update:visible="showInvitationPopup = $event"
    @send="handleInvitationSent"
  />
</template>
  <script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
import InvitationPopup from "./InvitationPopup.vue";

export default {
  props: {
    moduleRoute: String,
    headers: Array,
    moduleName: String,
    slug: String,
    dataRoute: String,
  },
  components: {
    BsIndex,
    AppLayout,
    InvitationPopup,
  },
  data() {
    return {
      showInvitationPopup: false,
    }
  },
  methods: {
    sendInvitation() {
      this.showInvitationPopup = true;
    },
    handleInvitationSent() {
      this.showInvitationPopup = false;
      this.$emit("invitation-sent");
    },
  },
};
</script>
  
  
  <style>
.main-content {
  background-color: #f3f4f6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding: 10px;
}
@media only screen and (max-width: 420px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
</style>